import {
  fetch
} from '@/api/service.js'
const serviceId = "/xyactivity/java-campus-c-operation";
//活动详情
export const getActivity = (data) => fetch('post', '', serviceId + '/activity/getActivity', data)
//参加活动
export const joinActivity = (data) => fetch('post', '', serviceId + '/user/joinActivity', data)
//提交评价
export const saveJobForecast = (data) => fetch('post', '', serviceId + '/jobForecast/saveJobForecast', data)
//获取城市
export const getProvinceList = (data) => fetch('post', '', serviceId + '/ztc/dict/getProvinceList', data)
//获取学校
export const getSchoolList = (data) => fetch('post', '', serviceId + '/ztc/dict/getSchoolList', data)
//获取专业
export const getEducationSpecialty = (data) => fetch('post', '', serviceId + '/ztc/dict/getEducationSpecialty', data)

//查看数据填写状态
export const getUserDataPhase = (data) => fetch('get', '', serviceId + '/user/getUserDataPhase', data)
//上传封面
// export const uploadCover = (data) => fetch('post', 'upload', serviceId + '/jobForecast/uploadCover', data)
//根据userId添加助力
export const saveJobForecastForHelp = (data) => fetch('get', '', serviceId + '/jobForecast/saveJobForecastForHelp', data)

/**
 * 校园拉新2021
 */
// 传播者打开链接
export const shareOpen = (data) => fetch('post', 'json', serviceId + '/activity/shareOpen', data)
// 查看传播者拉来的人员列表
export const listShareUsers = (data) => fetch('post', 'json', serviceId + '/activity/listShareUsers', data)
// 邀请人数
export const countShareUsers = (data) => fetch('post', 'json', serviceId + '/activity/countShareUsers', data)
// 获取最高学历
export const getEducation = (data) => fetch('post', '', serviceId + '/ztc/dict/getEducation', data)
// 参与者打开传播者链接
export const userOpen = (data) => fetch('post', 'json', serviceId + '/activity/userOpen', data)
// 参与者提交简历
export const userSubmit = (data) => fetch('post', 'json', serviceId + '/activity/userSubmit', data)
// 参与者选择免打扰
export const hideUserResume = (data) => fetch('get', '', serviceId + `/activity/hideUserResume`, data)

/**
 * 萌新活动2021
 */
// 获取登录人活动信息
export const senderOpen = (data) => fetch('post', 'json', serviceId + '/taskSender/senderOpen', data)
// 上传
export const uploadCover = (data) => fetch('post', 'upload', serviceId + '/taskSender/uploadCover', data)
// 提交活动信息
export const senderSubmit = (data) => fetch('post', 'json', serviceId + '/taskSender/senderSubmit', data)
// 参赛作品集锦
export const listCompetitionWorks = (data) => fetch('post', 'json', serviceId + '/taskSender/listCompetitionWorks', data)
// 排行榜
export const listGroupBoard = (data) => fetch('post', 'json', serviceId + '/taskSender/listGroupBoard', data)
// 获取发起人信息
export const getTaskSenderInfo = (data) => fetch('post', 'json', serviceId + '/taskSender/getTaskSenderInfo', data)
// 点赞
export const giveLike = (data) => fetch('post', 'json', serviceId + '/taskLike/giveLike', data)
// 根据助力活动id获取信息(kv图等等)
export const getTaskInfoById = (data, id) => fetch('get', 'json', serviceId + `/task/getTaskInfoById/${id}`, data)
